import {Inject, Injectable} from "@angular/core";
import {AnswerTemplateAggregate, AnswerTemplateGateway} from "../domain";
import {map, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {BASE_URL} from "../../tags/infra";
import {generateRequestTimeLogHeader} from "../../../core/interceptors/log.interceptor";

@Injectable()
export class AnswerTemplatesBffGateway extends AnswerTemplateGateway {

  constructor(private httpClient: HttpClient, @Inject(BASE_URL) private bffUrl: string) {
    super();
  }

  create(answerTemplate: AnswerTemplateAggregate): Observable<AnswerTemplateAggregate> {
    return this.httpClient.post(
        `${this.bffUrl}/answer-template`,
        { ...answerTemplate },
        { headers: generateRequestTimeLogHeader('answer-templates-create') }
      )
      .pipe(
        map((res) => answerTemplate)
      );
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(
      `${this.bffUrl}/answer-template/${id}`,
      { headers: generateRequestTimeLogHeader('answer-templates-delete') }
    );
  }

  list(companiesIds: Array<string>): Observable<Array<AnswerTemplateAggregate>> {
    return this.httpClient.get<Array<AnswerTemplateAggregate>>(
      `${this.bffUrl}/answer-template`,
      {
        params: {
          companiesIds
        },
        headers: generateRequestTimeLogHeader('answer-templates-list')
      });
  }

  update(answerTemplate: AnswerTemplateAggregate): Observable<AnswerTemplateAggregate> {
    return this.httpClient.put(
      `${this.bffUrl}/answer-template/${answerTemplate.idAnswerTemplate}`,
      {
        ...answerTemplate
      },
      { headers: generateRequestTimeLogHeader('answer-templates-update') })
      .pipe(
        map((res) => answerTemplate)
      );
  }

}
